import { useState } from "react";
import { DeleteRestObjectButton } from "../../rest/components/DeleteRestObjectButton";
import { Language } from "../../rest/models";
import { Button } from "../RequestRespectingInputs";
import { LanguageEditForm } from "./LanguageEditForm";

export function LanguageListRow(props: Props)
{
    const l = props.lang;
    const [isEditing, setIsEditing] = useState(false);

    if (isEditing)
    {
        //Create an edit form.
        return (
            <tr className='ernots_CreateFormWrapper' key={l.key}>
                <td colSpan={4}>
                    <LanguageEditForm lang={l} onDone={() => setIsEditing(false)}/>
                </td>
            </tr>)
    }
    else
    {
        const style={fontStyle: l.public ? "italic" : undefined};

        return (
            <tr className='ernots_ModelRow'>
                <td style={style}>{l.name}</td>
                <td style={style}>{l.gtrans_code}</td>
                <td className='ernots_CenteredCell'><Button onClick={e => setIsEditing(true)}>Edit</Button></td>
                <td className='ernots_CenteredCell'><DeleteRestObjectButton object={l} messageOnNewLine={true}/></td>
            </tr>
        );
    }
}

interface Props
{
    lang: Language;
}